import type { ApolloClient } from '@apollo/client'

/**
 * The client's default options, in their own module so the test setup can
 * give every MockedProvider's client the same ones without loading the app's
 * client (which opens a websocket).
 *
 * Apollo 4 notifies of every network status change by default; off is Apollo
 * 3's behaviour, where a refetch or poll leaves `loading` false and does not
 * re-run a `useQueryCallbacks` onCompleted. A query that wants the change
 * opts in.
 */
export const APOLLO_DEFAULT_OPTIONS: ApolloClient.DefaultOptions = {
  watchQuery: { notifyOnNetworkStatusChange: false },
}
